import { toaster } from "evergreen-ui";
import React, { Fragment, useContext } from "react";
import { useHistory } from "react-router-dom";
import Button from "../../components/Button";
import cookiesConfig from "../../utils/cookies.config";
import Logo from "../../assets/appstore.png";
import makeRequest from "../../utils/Request";
import { PartnerContext } from "../../utils/UserContext";

export default function Login() {
  const user = useContext(PartnerContext);
  const { push } = useHistory();

  const [loginRequest, { loading }] = makeRequest(
    { api: 2, path: "/auth/login", method: "POST" },
    {
      onCompleted: (d) => {
        cookiesConfig.setCipher(d?.data?.token, d?.data);
        user.setUserData(d?.data);
        push("/dashboard");
      },
      onError: (e) => {
        // console.log(e.response.data)
        toaster.danger(e?.response?.data.User || e?.message.toString());
      },
    }
  );

  async function handleLogin(e) {
    e.preventDefault();

    const payload = {
      username: e.target.username.value,
      password: e.target.password.value,
    };

    loginRequest(payload);
  }

  // console.log(loading);

  return (
    <Fragment>
      <div className="min-h-screen bg-white flex">
        <div className="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div>
              <img className="h-12 w-auto" src={Logo} alt="Workflow" />
              <h2 className="mt-6 text-2xl font-extrabold text-gray-600">
                Hyper <h2 className="text-yellow-500">Loyalty Supervisor</h2>
              </h2>
              <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
                Sign in to your account
              </h2>
              {/* <p className="mt-2 text-sm text-gray-600">
                Or
                <a
                  href="/"
                  className="font-medium text-yellow-600 hover:text-yellow-500"
                >
                  {" "}
                  create a merchant account
                </a>
              </p> */}
            </div>

            <div className="mt-8">
              <div className="mt-6">
                <form onSubmit={(e) => handleLogin(e)} className="space-y-6">
                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Phone Number
                    </label>
                    <div className="mt-1">
                      <input
                        id="username"
                        name="username"
                        required
                        className="appearance-none block w-full px-3 py-2 border border-gray-300  shadow-sm placeholder-gray-400 focus:outline-none focus:ring-yellow-500 focus:border-yellow-500 sm:text-sm"
                      />
                    </div>
                  </div>

                  <div className="space-y-1">
                    <label
                      htmlFor="password"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Password
                    </label>
                    <div className="mt-1">
                      <input
                        id="password"
                        name="password"
                        type="password"
                        autoComplete="current-password"
                        required
                        className="appearance-none block w-full px-3 py-2 border border-gray-300 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-yellow-500 focus:border-yellow-500 sm:text-sm"
                      />
                    </div>
                  </div>

                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <input
                        id="remember_me"
                        name="remember_me"
                        type="checkbox"
                        className="h-4 w-4 text-yellow-600 focus:ring-yellow-500 border-gray-300 rounded"
                      />
                      <label
                        for="remember_me"
                        className="ml-2 block text-sm text-gray-900"
                      >
                        Remember me
                      </label>
                    </div>

                    <div className="text-sm">
                      <a
                        href="/"
                        className="font-medium text-yellow-600 hover:text-yellow-500"
                      >
                        Forgot your password?
                      </a>
                    </div>
                  </div>

                  <div>
                    <Button
                      loading={loading === true}
                      type="submit"
                      title="Sign In"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="hidden lg:block relative w-0 flex-1">
          <img
            className="absolute inset-0 h-full w-full object-cover"
            src="https://images.unsplash.com/photo-1607434531924-050d4e675a44?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1950&q=80"
            alt=""
          />
        </div>
      </div>
    </Fragment>
  );
}
